<template>
  <div class="kye-filter-rule noselect" v-next>
    <el-table
      cell-class-name="kye-filter-rule-cell"
      :height="height"
      :data="rules"
      :stripe="false"
      :border="false"
      :highlight-current-row="false">
      <el-table-column width="68" align="center" label="(" label-class-name="td-front">
        <template slot-scope="scope">
          <div class="colindex cellindex">{{scope.$index+1}}</div>
          <el-input
            v-model="scope.row.frontBrackets"
            :disabled="scope.row.disabledFostBrackets"
            v-bind="frontBracketsAttr"
            style="width:26px;">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column width="110" align="left" label="查询条件">
        <template slot-scope="scope">
          <kye-select
            v-model="scope.row.key"
            placeholder="选择字段名"
            filterable
            default-first-option
            :clearable="false"
            :disabled="isDisabled(scope.row.key, scope.$index)"
            @change="clearFieldValue(scope.row)">
            <el-option
              v-for="opt in config.fields"
              :key="opt.key"
              v-if="opt.show"
              :label="opt.columnDisplayName || opt.label"
              :value="opt.key">
            </el-option>
          </kye-select>
        </template>
      </el-table-column>
      <el-table-column width="90" align="left" label="条件关系">
        <template slot-scope="scope">
          <kye-select
            v-model="scope.row.operation"
            placeholder="请选择"
            default-first-option
            :clearable="false"
            :disabled="isDisabled(scope.row.key, scope.$index)"
            @change="operationChange(scope.row)">
            <el-option
              v-for="opt in config.operations"
              v-if="isValidCompareOption(opt.value, scope.row)"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value">
            </el-option>
          </kye-select>
        </template>
      </el-table-column>
      <el-table-column align="left" label="条件值">
        <template slot-scope="scope">
          <template v-if="typeof scope.row.remoteMethod === 'function'">
            <template v-if="isAutoSwitch(scope.row)">
              <kye-select
                v-show="isEmptyOperation(scope.row)"
                clearable
                filterable
                :placeholder="setPlaceholder(scope.row) || '请搜索'"
                :remoteMethod="e => remoteMethod(e, scope.row, scope.$index)"
                v-model="scope.row.queryValue"
                v-bind="scope.row.$attr"
                @visible-change="e => selectVisibleChange(e, scope.row)"
                @change="queryValueChange(scope.row)">
                <el-option v-for="opt in scope.row.options" :key="opt.value" :label="opt.label" :value="opt.value">
                </el-option>
              </kye-select>
              <kye-select
                v-show="!isEmptyOperation(scope.row)"
                class="kye-select--multiple"
                multiple
                collapse-tags
                filterable
                :placeholder="setPlaceholder(scope.row) || '请搜索'"
                :remoteMethod="e => remoteMethod(e, scope.row, scope.$index)"
                v-model="scope.row.queryValue2"
                v-bind="scope.row.$attr"
                @visible-change="e => selectVisibleChange(e, scope.row)"
                @change="queryValueChange(scope.row)">
                <el-option v-for="opt in scope.row.options" :key="opt.value" :label="opt.label" :value="opt.value">
                </el-option>
            </kye-select>
            </template>
            <template v-else>
              <kye-select
                :ref="`remoteSelect${scope.$index}`"
                class="kye-select--multiple"
                :placeholder="setPlaceholder(scope.row) || '请搜索'"
                v-bind="scope.row.$attr"
                :key="scope.row.key"
                clearable
                filterable
                :user="scope.row.columnType === 'user' || scope.row.$attr.user === true"
                :remoteMethod="e => remoteMethod(e, scope.row, scope.$index)"
                :loading="scope.row.loading"
                :value="scope.row.$attr.multiple ? (Array.isArray(scope.row.queryValue2) ? scope.row.queryValue2 : []) : scope.row.queryValue"
                :labels="selectedLabels(scope.row.options, scope.row.queryValue2, scope.row.$attr.multiple)"
                @input="e => bindChange(e, scope.row)"
                @change="queryValueChange(scope.row)"
                @visible-change="e => selectVisibleChange(e, scope.row)">
                <kye-option
                  v-for="opt in scope.row.options"
                  :class="opt.optionDisabled ? 'kyeuseroff' : ''"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value">
                </kye-option>
              </kye-select>
            </template>
          </template>
          <div v-else-if="isInputRange(scope.row)" style="display:flex;">
            <kye-number
              v-model="scope.row.queryValue"
              v-bind="scope.row.$attr"
              style="flex:1;"
              :placeholder="setPlaceholder(scope.row) || '请输入数字'">
            </kye-number>
            <span style="padding: 0 4px;line-height: 28px;">-</span>
            <kye-number
              v-model="scope.row._queryValue"
              v-bind="scope.row.$attr"
              style="flex:1;"
              :placeholder="setPlaceholder(scope.row) || '请输入数字'">
            </kye-number>
          </div>
          <el-radio-group
            v-else-if="isInputNumberComponent(scope.row) && scope.row.$attr.null && ['equal', 'not_equal'].includes(scope.row.operation)"
            v-model="scope.row._queryValue"
            @change="e => radioNumberChange(scope.row, e)">
            <el-radio label="number" style="width:182px;">
              <kye-number
                style="width: 92%"
                v-model="scope.row.queryValue"
                v-bind="scope.row.$attr"
                :disabled="scope.row._queryValue === 'null'"
                :placeholder="setPlaceholder(scope.row) || '请输入数字'">
              </kye-number>
            </el-radio>
            <el-radio label="null">
              <el-input
                style="width:30px;"
                :disabled="scope.row._queryValue !== 'null'"
                value="(空)"
                readonly>
              </el-input>
            </el-radio>
          </el-radio-group>
          <kye-number
            v-else-if="isInputNumberComponent(scope.row)"
            v-model="scope.row.queryValue"
            v-bind="scope.row.$attr"
            :placeholder="setPlaceholder(scope.row) || '请输入数字'">
          </kye-number>
          <template v-else-if="isInputComponent(scope.row)">
            <el-radio-group
              v-if="scope.row.$attr.null && ['equal', 'not_equal'].includes(scope.row.operation)"
              v-model="scope.row._queryValue"
              @change="e => radioInputChange(scope.row, e)">
              <el-radio label="text" style="width:182px;">
                <el-input
                  style="width:92%;"
                  v-model.trim="scope.row.queryValue"
                  v-bind="scope.row.$attr"
                  :disabled="scope.row._queryValue === 'null'"
                  :placeholder="setPlaceholder(scope.row) || '请输入内容'">
                </el-input>
              </el-radio>
              <el-radio label="null">
                <el-input
                  style="width:30px;"
                  :disabled="scope.row._queryValue !== 'null'"
                  value="(空)"
                  readonly>
                </el-input>
              </el-radio>
            </el-radio-group>
            <el-input
              v-else
              v-model.trim="scope.row.queryValue"
              v-bind="scope.row.$attr"
              :placeholder="setPlaceholder(scope.row) || '请输入内容'">
            </el-input>
          </template>
          <template v-else-if="getComponentType(scope.row) === 'enum'">
            <kye-select
              v-show="isEmptyOperation(scope.row)"
              clearable
              filterable
              default-first-option
              :placeholder="setPlaceholder(scope.row) || '请选择'"
              v-model="scope.row.queryValue"
              v-bind="scope.row.$attr"
              @change="queryValueChange(scope.row)">
              <el-option
                v-for="opt in getFieldOptions(scope.row)"
                :key="opt.value"
                :label="opt.label || ' '"
                :value="opt.value">
              </el-option>
            </kye-select>
            <kye-select
              v-show="!isEmptyOperation(scope.row)"
              class="kye-select--multiple"
              multiple
              collapse-tags
              filterable
              default-first-option
              :placeholder="setPlaceholder(scope.row) || '请选择'"
              v-model="scope.row.queryValue2"
              v-bind="scope.row.$attr"
              :labels="selectedLabels(getFieldOptions(scope.row), scope.row.queryValue2, true)"
              @change="queryValueChange(scope.row)">
              <el-option
                v-for="opt in getFieldOptions(scope.row)"
                :key="opt.value"
                :label="opt.label || ' '"
                :value="opt.value">
              </el-option>
            </kye-select>
          </template>
          <template v-else-if="getComponentType(scope.row) === 'date'">
            <el-radio-group
              v-if="scope.row.operation === 'equal' && scope.row.$attr.null !== false"
              v-model="scope.row._queryValue"
              @change="e => radioDateChange(scope.row, e)">
              <el-radio label="date" style="width:182px;">
                <el-time-picker
                  v-if="getSelectField(scope.row).lookupCode === 'time'"
                  v-model="scope.row.queryValue"
                  style="width:92%;"
                  v-bind="scope.row.$attr"
                  :format="scope.row.$attr.format || 'HH:mm:ss'"
                  :value-format="scope.row.$attr.valueFormat || 'HH:mm:ss'"
                  :disabled="scope.row._queryValue === 'null'"
                  :clearable="false"
                  placeholder="请选择时间">
                </el-time-picker>
                <template v-else-if="getSelectField(scope.row).lookupCode === 'datePicker2'">
                  <kye-date-picker2
                    v-if="isDateMultiple(scope.row)"
                    v-model="scope.row.queryValue2"
                    style="width:92%;"
                    v-bind="scope.row.$attr"
                    :disabled="scope.row._queryValue === 'null'"
                    :operation="scope.row.operation"
                    :type="getDatePickerType(scope.row.key)"
                    @input="(val) => datePickerChange(val, scope.row)">
                  </kye-date-picker2>
                  <kye-date-picker2
                    v-else
                    v-model="scope.row.queryValue"
                    style="width:92%;"
                    v-bind="scope.row.$attr"
                    :disabled="scope.row._queryValue === 'null'"
                    :operation="scope.row.operation"
                    :type="getDatePickerType(scope.row.key)"
                    @input="(val) => datePickerChange(val, scope.row)">
                  </kye-date-picker2>
                </template>
                <kye-date-picker3
                  v-else-if="getSelectField(scope.row).lookupCode === 'datePicker3'"
                  v-model="scope.row.queryValue"
                  style="width: 92%; display: inline-block"
                  v-bind="scope.row.$attr"
                  :disabled="scope.row._queryValue === 'null'"
                  :clearable="false"
                  :operation="scope.row.operation"
                  :type="getDatePickerType(scope.row.key)"
                  @input="val => datePickerChange(val, scope.row)">
                </kye-date-picker3>
                <kye-date-picker
                  v-else
                  v-model="scope.row.queryValue"
                  style="width:92%;"
                  v-bind="scope.row.$attr"
                  :disabled="scope.row._queryValue === 'null'"
                  :clearable="false"
                  :operation="scope.row.operation"
                  :type="getDatePickerType(scope.row.key)"
                  @input="(val) => datePickerChange(val, scope.row)">
                </kye-date-picker>
              </el-radio>
              <el-radio label="null">
                <el-input
                  style="width:30px;"
                  :disabled="scope.row._queryValue !== 'null'"
                  value="(空)"
                  readonly>
                </el-input>
              </el-radio>
            </el-radio-group>
            <el-input v-else-if="scope.row.operation === 'not_equal'" value="(空)" disabled />
            <template v-else>
              <template v-if="getSelectField(scope.row).lookupCode === 'time'">
                <el-time-picker
                  v-show="!isRange(scope.row)"
                  v-model="scope.row.queryValue"
                  v-bind="scope.row.$attr"
                  :format="scope.row.$attr.format || 'HH:mm:ss'"
                  :value-format="scope.row.$attr.valueFormat || 'HH:mm:ss'"
                  :clearable="false"
                  placeholder="请选择时间">
                </el-time-picker>
                <el-time-picker
                  v-model="scope.row.queryValue2"
                  v-show="isRange(scope.row)"
                  v-bind="scope.row.$attr"
                  :format="scope.row.$attr.format || 'HH:mm:ss'"
                  :value-format="scope.row.$attr.valueFormat || 'HH:mm:ss'"
                  is-range
                  :clearable="false"
                  start-placeholder="开始时间"
                  end-placeholder="结束日时间">
                </el-time-picker>
              </template>
              <template v-else-if="getSelectField(scope.row).lookupCode === 'datePicker2'">
                <kye-date-picker2
                  v-show="!isRange(scope.row)"
                  v-model="scope.row.queryValue"
                  v-bind="scope.row.$attr"
                  :operation="scope.row.operation"
                  :type="getDatePickerType(scope.row.key)"
                  placeholder="请选择日期"
                  @input="(val) => datePickerChange(val, scope.row)">
                </kye-date-picker2>
                <kye-date-picker2
                  v-model="scope.row.queryValue2"
                  v-show="isRange(scope.row)"
                  v-bind="scope.row.$attr"
                  :operation="scope.row.operation"
                  :type="getDatePickerType(scope.row.key, true)"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @input="(val) => datePickerChange(val, scope.row)">
                </kye-date-picker2>
              </template>
              <template v-else-if="getSelectField(scope.row).lookupCode === 'datePicker3'">
                <kye-date-picker3
                  v-show="!isRange(scope.row)"
                  v-model="scope.row.queryValue"
                  v-bind="scope.row.$attr"
                  :clearable="false"
                  :operation="scope.row.operation"
                  :type="getDatePickerType(scope.row.key)"
                  placeholder="请选择日期"
                  @input="val => datePickerChange(val, scope.row)">
                </kye-date-picker3>
                <kye-date-picker3
                  v-model="scope.row.queryValue2"
                  v-show="isRange(scope.row)"
                  v-bind="scope.row.$attr"
                  :clearable="false"
                  :operation="scope.row.operation"
                  :type="getDatePickerType(scope.row.key, true)"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @input="val => datePickerChange(val, scope.row)">
                </kye-date-picker3>
              </template>
              <template v-else>
                <kye-date-picker
                  v-show="!isRange(scope.row)"
                  v-model="scope.row.queryValue"
                  v-bind="scope.row.$attr"
                  :clearable="false"
                  :operation="scope.row.operation"
                  :type="getDatePickerType(scope.row.key)"
                  placeholder="请选择日期"
                  @input="(val) => datePickerChange(val, scope.row)">
                </kye-date-picker>
                <kye-date-picker
                  v-model="scope.row.queryValue2"
                  v-show="isRange(scope.row)"
                  v-bind="scope.row.$attr"
                  :clearable="false"
                  :operation="scope.row.operation"
                  :type="getDatePickerType(scope.row.key, true)"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @input="(val) => datePickerChange(val, scope.row)">
                </kye-date-picker>
              </template>
            </template>
          </template>
          <kye-area-remote
            v-else-if="getComponentType(scope.row) === 'area'"
            v-model="scope.row.queryValue2"
            :level="scope.row.$attr.options.length"
            :labels="scope.row.$attr.labels">
          </kye-area-remote>
          <el-input
            v-else-if="getComponentType(scope.row) === 'dept'"
            v-bind="scope.row.$attr"
            readonly
            :placeholder="setPlaceholder(scope.row) || '点击可选择组织'"
            :value="showDeptLabel(scope.row)"
            @focus="openDeptTree(scope.row, scope.$index)">
          </el-input>
          <formatter v-else-if="getComponentType(scope.row) === 'customComponent'" :option="warpCustomComponentsOption(scope.row)" v-bind="scope.row.$attr" />
          <el-input placeholder="请选择查询条件和条件关系" disabled v-else></el-input>
        </template>
      </el-table-column>
      <el-table-column width="32" align="center" label=")" label-class-name="td-post">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.postBrackets"
            :disabled="scope.row.disabledPostBrackets"
            v-bind="postBracketsAttr"
            style="width:26px;">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column width="96" align="left" label="">
        <template slot-scope="scope">
          <kye-select
            :key="scope.row.key"
            v-model="scope.row.conditionOperation"
            :disabled="scope.row.disabledCondition"
            :clearable="false"
            style="width:35px;">
            <el-option
              v-for="opt in config.conditionOperation"
              :disabled="scope.row.$attr.rowCondition && opt.value !== scope.row.$attr.rowCondition"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value">
            </el-option>
          </kye-select>
          <i class="layout layout-remove"
             v-show="showDeleteIcon(scope.row.key, scope.$index)"
             @click="deleteRule(scope.$index)">
          </i>
          <i class="layout layout-plus2"
              v-show="showAddIcon(scope.row.key, scope.$index)"
              @click="insertRule(scope.$index + 1)">
            </i>
        </template>
      </el-table-column>
    </el-table>
    <dept-dialog
      ref="deptDialog"
      :preloadDeptTree="false"
      :checkNodeSelect="checkNodeSelect"
      @change="deptChange">
    </dept-dialog>
    <dept-multiple-dialog ref="deptMultipleDialog" :preloadDeptTree="false" @change="deptChange"></dept-multiple-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import { getGenericSearchConfig } from 'public/utils/common-api'
  import DeptDialog from './dept-dialog'
  import DeptMultipleDialog from './dept-multiple-dialog'
  import mixins from '../../mixins/index'
  import {
    OPERATIONS,
    COLUMN_TYPE,
    COMPARES,
    SINGLE_VALUE,
    perfectVos,
    remoteSelectMethod,
    navigateSelectFirstOption,
    createOnInputReplacer
  } from './utils'
  import { getMenuIdByRoute } from '../../utils'
  import Formatter from './form-item-formatter'
  import { createRemoteModel } from './module/custom-filter/create-rules'

  export default {
    mixins: [mixins],
    name: 'filter-rule',
    components: { DeptDialog, DeptMultipleDialog, Formatter },
    props: {
      inner: Boolean,
      height: [String, Number],
      maxRows: [String, Number],
      searchCodes: { // 通用查询编码集合，对于通用查询配置比较多的模块，可传入此参数，减少响应时间
        type: Array,
        default: () => ([])
      },
      module: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      const lookUpOptions = this.$store.getters.lookUpOptions
      return {
        showIndex: -1, // 弹窗组件对应 rules 索引
        rules: [this.createdModel()],
        config: {
          esFlag: true,
          fields: {},
          conditionOperation: lookUpOptions['system_GenericQuery_conditionOperation'],
          operations: lookUpOptions['system_GenericQuery_Operation']
          },
        frontBracketsAttr: createOnInputReplacer(/[^(（]/g),
        postBracketsAttr: createOnInputReplacer(/[^)）]/g)
      }
    },
    async created () {
      // this.fieldOptionsCache = {}
      if (!this.module.option) {
        this.module.option = {}
      }
      if (!this.inner && this.module.searchCode) {
        // let menuId = this.$store.getters.menus[this.$route.meta.tag].id
        let menu = getMenuIdByRoute(this.$store, this.$route)
        let menuId = menu && menu.id
        let rs = await getGenericSearchConfig(menuId, this.$props.searchCodes)
        if (rs && rs.length) {
          let obj = rs.find(v => v.searchCode === this.module.searchCode)
          if (obj && obj.columnList && obj.columnList.length) {
            this.config.esFlag = obj.esFlag === '10'
            obj.columnList.forEach(v => {
              v.key = this.config.esFlag ? v.propertyName : v.columnName
            })
            this.setGenericSearchFields(obj.columnList)
          }
        }
      }
    },
    beforeDestroy () {
      this.scrollDom = null
    },
    methods: {
      createdModel () {
        return {
          key: '',
          propertyName: '',
          columnName: '',
          frontBrackets: '(',
          postBrackets: ')',
          disabledFostBrackets: false,
          disabledPostBrackets: false,
          disabledCondition: false,
          conditionOperation: 'and',
          operation: '',
          columnType: '',
          queryValue: '',
          queryValue2: null,
          _queryValue: '',
          $attr: {}
        }
      },
      createdDefaultModel () {
        let arr = []
        Object.keys(this.module.option).forEach(v => {
          const conf = this.module.option[v]
          const field = this.config.fields[v]
          const isDefault = conf.required && conf.operation
          // 字段默认值
          if (field && isDefault) {
            let model = this.createdModel()
            model._required = true // 根据标识判断是否必填
            model.key = v
            model.propertyName = field.propertyName
            model.columnName = field.columnName
            model.columnType = field.columnType
            model.operation = conf.operation
            model.disabledFostBrackets = conf.disabledFostBrackets
            model.disabledPostBrackets = conf.disabledPostBrackets
            model.disabledCondition = conf.disabledCondition
            model._prevOperation = conf.operation
            model.$attr = field.$attr
            let value = conf.default
            if (model.columnType === COLUMN_TYPE.date) {
              if (this.isRange(model)) {
                model.queryValue2 = Array.isArray(value) && value.length
                  ? value.map(v => this.formatTime(v, field.lookupCode))
                  : null
              } else {
                model.queryValue = this.formatTime(value, field.lookupCode)
              }
            } else {
              // 2023-03-25 远程下拉搜索、远程搜索默认值
              if (field.remoteMethod) {
                model = {
                  ...model,
                  ...createRemoteModel(value, field)
                }
              } else {
                model.queryValue2 = value
                if (Array.isArray(value)) {
                  model.queryValue = value[0]
                  model._queryValue = value[1]
                } else {
                  model.queryValue = value
                }
              }
            }
            arr.push(model)
          }
        })
        if (arr.length === 0) {
          arr.push(this.createdModel())
        }
        return arr
      },
      // 对外暴露，merge 查询条件
      setGenericFields (option) {
        Object.keys(option).forEach(v => {
          let opt = this.config.fields[v]
          if (opt) {
            Object.assign(opt, option[v])
          }
        })
      },
      // 合并查询条件，排序
      mergeGenericFields (option) {
        const originFields = this.config.fields
        this.config.fields = Object.keys(option).reduce((prev, key) => {
          let opt = originFields[key]
          prev[key] = Object.assign(opt, option[key])
          return prev
        }, {})
      },
      setGenericSearchFields (fields, esFlag) {
        if (esFlag !== void 0) {
          this.config.esFlag = esFlag
        }
        if (!Object.keys(this.config.fields).length) {
          this.perfectModuleOption(fields)
          this.config.fields = fields.reduce((s, v) => {
            // merge 前端的配置
            v.$attr = Object.assign(v.$attr || {}, this.module.option[v.key])
            // 后台扩展字段支持前端属性
            let attr = v.attribute2
            if (attr) {
              if (typeof attr === 'string') {
                try {
                  attr = JSON.parse(attr)
                } catch (e) {
                }
              }
              if (typeof attr === 'object') {
                // 前端的配置覆盖模板的配置
                Object.assign(attr, v.$attr)
                Object.assign(v.$attr, attr)
              }
            }

            this.$set(v, 'show', v.show === undefined ? true : !!v.show)

            let type = v.columnType === 'component' ? (v.lookupCode || COLUMN_TYPE.string) : v.columnType
            v.columnType = type
            v.remoteMethod = v.$attr.remoteMethod
            if (type === COLUMN_TYPE.area) {
              let labels = v.$attr.options.map(v => v.label)
              v.label = labels.join('-')
              v.$attr.labels = labels
            } else if (type === COLUMN_TYPE.user) {
              v.remoteMethod = val => this.searchUser(val, v)
              v.$attr.remote = true
            } else if (type === COLUMN_TYPE.department) {
              v.remoteMethod = this.searchDepartment
              v.$attr.remote = true
            } else if (type === COLUMN_TYPE.date) {
              if (v.lookupCode === 'time') {
                v.$attr.type = v.$attr.type || 'time'
                v.$attr.format = v.$attr.format || 'HH:mm:ss'
                v.$attr.valueFormat = v.$attr.valueFormat || 'HH:mm:ss'
              } else {
                v.$attr.type = v.$attr.type || 'datetime'
                v.$attr.format = v.$attr.format || 'yyyy-MM-dd HH:mm'
                v.$attr.valueFormat = v.$attr.valueFormat || 'yyyy-MM-dd HH:mm:ss'
              }
            }
            s[v.key] = v
            return s
          }, {})
          this.rules = this.createdDefaultModel()
        }
        this.$emit('created')
      },
      // 完善前端配置（Y/N)
      perfectModuleOption (fields) {
        Object.keys(this.module.option).forEach(k => {
          fields.some(v => {
            if (k === v.propertyName) {
              this.module.option[v.columnName] = this.module.option[k]
              return true
            }
            if (k === v.columnName) {
              this.module.option[v.propertyName] = this.module.option[k]
              return true
            }
            return false
          })
        })
      },
      getValidRules () {
        let arr = []
        this.rules.forEach(v => {
          if (v.operation && (this.isValidQueryValue(v) || v._required)) {
            let o = {
              propertyName: v.propertyName,
              columnName: v.columnName,
              frontBrackets: v.frontBrackets,
              postBrackets: v.postBrackets,
              conditionOperation: v.conditionOperation,
              operation: v.operation,
              queryValue: this.getQueryValueTemplate(v),
              required: v._required,
              extJson: this.setExtJson(v)
            }
            arr.push(o)
          }
        })
        if (arr.length > 0) {
          return arr
        }
        return null
      },
      getRules () {
        return this.rules
      },
      setRules (rules) {
        if (rules && typeof rules === 'string') {
          try {
            rules = JSON.parse(rules)
          } catch (e) {
            rules = null
          }
        }
        const rulesKeySet = new Set() // 收集回显字段
        if (Array.isArray(rules) && rules.length) {
          let key = this.config.esFlag ? 'propertyName' : 'columnName'
          let fields = this.config.fields
          const templateRequired = this.module.templateRequired
          this.rules = rules.filter(v => {
            let field = fields[v[key]]
            if (!field || field.show === false) {
              return false
            }
            let type = field.columnType
            // 扩展字段
            let ext = {}
            try {
              ext = JSON.parse(v.extJson)
            } catch (e) {
              ext = {}
            }
            v.key = v[key]
            rulesKeySet.add(v.key)
            v.columnType = type
            v.$attr = { ...(field.$attr || {}) }
            v._required = templateRequired ? ext.required : v.required
            v._prevOperation = v.operation
            v._queryValue = ''
            v.queryValue2 = null
            if (!v.conditionOperation) {
              v.conditionOperation = 'and'
            }
            let value = v.values || v.queryValue || []
            const lookupCode = field.lookupCode
            // 解析模板值
            if (field.remoteMethod) {
              v.remoteMethod = field.remoteMethod
              // 2022-11-28 增加属性
              v.labelKey = field.$attr.labelKey
              v.valueKey = field.$attr.valueKey
              v.options = []
              // 动态切换是否多选，让内部方法执行接口缓存处理
              if (this.isAutoSwitch(v)) {
                v.$attr.multiple = !this.isEmptyOperation(v)
              }
              try {
                let arr = JSON.parse(value)
                v.options = Array.isArray(arr) ? arr : []
                if (v.$attr.multiple || (this.isAutoSwitch(v) && !this.isEmptyOperation(v))) {
                  v.allSearchResult = arr.reduce((prev, cur) => {
                    prev[cur.value] = cur
                    return prev
                  }, {})
                }
                value = arr.map(item => item.value)
              } catch (e) {
                value = value.split(',')
              }
            } else if (type === COLUMN_TYPE.dept) {
              try {
                let arr = JSON.parse(value)
                value = arr[0].value
                v._queryValue = arr
              } catch (e) {
                value = value.split(',')
                v._queryValue = value
              }
              v.queryValue2 = value
              if (ext.hasOwnProperty('containLeaf')) {
                v._containLeaf = ext.containLeaf
              }
              v._idsInfo = ext.idsInfo || []
            } else if (value && typeof value === 'string') {
              value = value.split(',')
            }
            // 将值拆分到对应字段
            if (type === COLUMN_TYPE.date) {
              if ((!lookupCode || lookupCode === 'datePicker3') && v.operation === OPERATIONS.equal) {
                v.queryValue = value[0].replace('null', '')
                v._queryValue = value[0] === 'null' ? 'null' : 'date'
              } else {
                v.queryValue = v.operation === OPERATIONS.between ? '' : this.formatTime(value[0], field.lookupCode)
              }
              v.queryValue2 = value.length === 2 ? value.map(v => this.formatTime(v, field.lookupCode)) : []
              if (field.lookupCode === 'datePicker2' && this.isDateMultiple(field)) {
                v.queryValue2 = value
              }
            } else if (type === COLUMN_TYPE.area) {
              v.queryValue2 = value.map(v => ({ id: v }))
            } else if (this.isInputComponent({ columnType: type }) && !field.remoteMethod) {
              if (field.$attr.null && ['equal', 'not_equal'].includes(v.operation) && v.queryValue === 'null') {
                v.queryValue = ''
                v._queryValue = 'null'
              } else {
                v.queryValue = value.join(',')
                v._queryValue = 'text'
              }
            } else if (type === COLUMN_TYPE.customComponent) {
              try {
                let arr = JSON.parse(value)
                v.queryValue = (arr[0] && arr[0].label) || ''
                v._queryValue = arr
                v.queryValue2 = (arr[0] && arr[0].value) || ''
              } catch (e) {
                v.queryValue = ''
                v._queryValue = [{ value: value, label: '' }]
                v.queryValue2 = value
              }
            } else if (type !== COLUMN_TYPE.dept) {
              v.queryValue = value[0]
              v._queryValue = value[1]
              v.queryValue2 = value
              // 处理数字文本不等于或等于且可选空场景的赋值
              if (this.isInputNumberComponent(field) && field.$attr.null && ['equal', 'not_equal'].includes(v.operation)) {
                v._queryValue = v.queryValue === 'null' ? 'null' : 'number'
              }
            }
            return true
          })


          // 模板回显必填
          if (templateRequired) {
            // 必填字段不在模版里面（新增必填字段
            const optionRules = this.createdDefaultModel()
            for (let i = 0; i < optionRules.length; i++) {
              const model = optionRules[i]
              // 不存在key跳过。否则会多添加
              if (!model.key) {
                continue
              }
              // 添加不存在的默认值
              if (!rulesKeySet.has(model.key)) {
                this.rules.unshift(model)
              }
              // 默认值里面，代码中的required与配置的JSON的required之间的对比
              const noRequired = this.rules.filter(item => item.key === model.key).every(item => !item._required)
              if (noRequired) {
                this.rules.unshift(model)
              }
            }
          }

          // 2022-09-06 处理异常情况，例如缓存 GLOBAL_SEARCH_GENERIC 里的查询数据字段已被删除，现有字段无法匹配情况
          if (this.rules.length === 0) {
            this.rules.push(this.createdModel())
          }
        }
      },
      appendGenericVos () {
        const vos = []
        const componentMap = {
          [COLUMN_TYPE.user]: COLUMN_TYPE.string,
          [COLUMN_TYPE.department]: COLUMN_TYPE.string,
          [COLUMN_TYPE.phone]: COLUMN_TYPE.string,
          [COLUMN_TYPE.dept]: COLUMN_TYPE.string,
          [COLUMN_TYPE.customComponent]: COLUMN_TYPE.string
        }
        this.rules.forEach(obj => {
          let values = this.getQueryValue(obj)
          let type = obj.columnType
          let vo = {
            propertyName: obj.propertyName,
            columnName: obj.columnName,
            frontBrackets: obj.frontBrackets,
            postBrackets: obj.postBrackets,
            conditionOperation: obj.conditionOperation,
            operation: obj.operation,
            type: componentMap[type] || type,
            values
          }
          // 扩展字段
          let field = this.config.fields[obj.key] || {}
          if (field.attribute1) {
            try {
              Object.assign(vo, JSON.parse(field.attribute1))
            } catch (e) {
            }
          }
          if (type === COLUMN_TYPE.area) {
            let options = field.$attr.options
            let lastIndex = values.length - 1
            values.forEach((v, index) => {
              if (v) {
                let opt = options[index]
                vos.push({
                  propertyName: opt.propertyName,
                  columnName: opt.columnName,
                  // 2022-07-18 首位两端取用户输入值
                  frontBrackets: index === 0 ? obj.frontBrackets : '(',
                  postBrackets: index === lastIndex ? obj.postBrackets : ')',
                  conditionOperation: index === lastIndex ? obj.conditionOperation : 'and',
                  operation: obj.operation,
                  type: opt.columnType,
                  idsInfo: obj.queryValue2,
                  values: [v]
                })
              }
            })
          } else if (type === COLUMN_TYPE.date && obj.operation === OPERATIONS.equal) {
            if (obj._queryValue === 'null') {
              vo.values = ['null']
            } else {
              const lookupCode = this.getSelectField(obj).lookupCode
              const type = field.$attr.type || 'date'
              if (lookupCode !== 'datePicker2') {
                vo.values = this.calculateDateRange(obj.queryValue, type, obj.$attr.valueFormat)
              }
              if (type.includes('date')) {
                vo.operation = OPERATIONS.between
              }
              if (type === 'months') {
                vo.type = COLUMN_TYPE.enum
                vo.operation = OPERATIONS.contain
              }
            }
            vos.push(vo)
          } else if (type === COLUMN_TYPE.dept) {
            // 是否包含子节点
            vo.containLeaf = obj._containLeaf
            vo.idsInfo = obj._idsInfo
            if (obj.operation.includes(OPERATIONS.contain)) {
              vo.type = COLUMN_TYPE.enum
            }
            vos.push(vo)
          } else {
            vos.push(vo)
          }
        })
        return vos
      },
      onReset () {
        this.rules = this.createdDefaultModel()
      },
      onSubmit () {
        let frontNum = 0
        let postNum = 0
        for (let i = 0, l = this.rules.length; i < l; i++) {
          let obj = this.rules[i]
          if (!this.isValidQueryValue(obj)) {
            this.$message.warning(`第${i + 1}行的条件值不能为空`)
            return null
          }
          if (!obj.operation) {
            this.$message.warning(`第${i + 1}行的条件关系不能为空`)
            return null
          }
          if (this.isInputComponent(obj) && this.getQueryValue(obj).join().length > 255) {
            this.$message.warning(`第${i + 1}行的条件值字符长度不能大于255`)
            return null
          }
          obj.frontBrackets = obj.frontBrackets ? obj.frontBrackets.replace(/（/g, '(') : ''
          obj.postBrackets = obj.postBrackets ? obj.postBrackets.replace(/）/g, ')') : ''
          frontNum += obj.frontBrackets.length
          postNum += obj.postBrackets.length
        }
        if (frontNum !== postNum) {
          this.$message.warning('前后括号数量不一致！')
          return null
        }
        const vos = this.appendGenericVos()
        perfectVos(vos)
        return vos
      },
      mapColumnList () {
        return this.rules.map((v, i) => {
          return {
            rowIndex: i + 1,
            propertyName: v.propertyName,
            columnName: v.columnName,
            frontBrackettemplates: v.frontBrackets,
            postBrackets: v.postBrackets,
            conditionOperation: v.conditionOperation,
            operation: v.operation,
            queryValue: this.getQueryValueTemplate(v),
            extJson: this.setExtJson(v)
          }
        })
      },
      setExtJson (model) {
        let obj = {
          required: model._required
        }
        const type = model.columnType
        if (type === COLUMN_TYPE.dept) {
          // 是否包含子节点
          obj.containLeaf = model._containLeaf
          obj.idsInfo = model._idsInfo
        }
        return JSON.stringify(obj)
      },
      addRule () {
        this.rules.push(this.createdModel())
      },
      insertRule (index) {
        this.rules.splice(index, 0, this.createdModel())
        if (!this.scrollDom) {
          this.scrollDom = this.$el.querySelector('.el-table__body-wrapper')
        }
        if (this.scrollDom && index > 1) {
          this.scrollDom.scrollTo({ top: 34 * (index - 1), behavior: 'smooth' })
        }
      },
      deleteRule (index) {
        this.rules.splice(index, 1)
      },
      isDateMultiple (model) {
        return model.$attr.type === 'months'
      },
      getQueryValue (model, isTemplate) {
        let { columnType, queryValue, queryValue2, operation } = model
        if (typeof model.remoteMethod === 'function' && this.isAutoSwitch(model)) {
          return this.isEmptyOperation(model) ? [queryValue] : queryValue2
        }
        if (this.isInputComponent({ columnType })) {
          if (model._queryValue === 'null') {
            return ['null']
          }
        }
        if (columnType === COLUMN_TYPE.number) {
          if (operation === OPERATIONS.between) {
            return [+queryValue, +model._queryValue]
          }
          return isNaN(queryValue) ? [queryValue] : [+queryValue]
        }
        if (columnType === COLUMN_TYPE.user && model.$attr.multiple) {
          return queryValue2
        }
        if (SINGLE_VALUE.includes(columnType)) {
          return [queryValue]
        }
        if (columnType === COLUMN_TYPE.enum && this.isEmptyOperation(model)) {
          return [queryValue]
        }
        if (columnType === COLUMN_TYPE.date) {
          let lookupCode = this.getSelectField(model).lookupCode
          let valueFormat = model.$attr.valueFormat
          if (lookupCode === 'datePicker2' && this.isDateMultiple(model)) {
            return queryValue2
          }
          if (this.isRange(model)) {
            return queryValue2.map(v => this.splitTime(v, lookupCode, valueFormat))
          } else if (isTemplate && operation === OPERATIONS.equal && !queryValue) {
            return ['null']
          } else {
            return [this.splitTime(queryValue, lookupCode, valueFormat)]
          }
        }
        if (columnType === COLUMN_TYPE.area) {
          return queryValue2.map(v => v.id)
        }
        return queryValue2
      },
      getQueryValueTemplate (model) {
        // 员工、部门 等远程搜索组件 和 9级组织
        // 保存模板时，需要同时保存 [{label,value}]，这样才能在加载模板时显示 label
        let { columnType, queryValue, queryValue2 } = model
        if (model.remoteMethod) {
          if (model.$attr.multiple || (this.isAutoSwitch(model) && !this.isEmptyOperation(model))) {
            let arr = queryValue2.map(v => model.allSearchResult[v])
            arr = arr.map(v => ({ label: v.label, value: v.value }))
            return JSON.stringify(arr)
          } else {
            let obj = model.options.find(v => v.value === queryValue) || {}
            obj = { label: obj.label, value: obj.value }
            return JSON.stringify([obj])
          }
        }
        if (columnType === COLUMN_TYPE.dept || columnType === COLUMN_TYPE.customComponent) {
          return JSON.stringify(model._queryValue)
        }
        return this.getQueryValue(model, true).join()
      },
      // 不等于/等于单选 自动切换为 包含/不包含多选
      isAutoSwitch (row) {
        const obj = this.getSelectField(row)
        return obj.$attr && obj.$attr.autoSwitchMode === true
      },
      isEmptyOperation ({ operation }) {
        return operation === OPERATIONS.equal || operation === OPERATIONS.not_equal
      },
      isRange ({ operation }) {
        return operation === OPERATIONS.between || operation === OPERATIONS.not_between
      },
      isValidQueryValue (model) {
        let { columnType, queryValue, queryValue2, operation } = model
        if (this.isInputComponent({ columnType }) && model.$attr.null && (queryValue || model._queryValue === 'null')) {
          return true
        }
        if (columnType === COLUMN_TYPE.user && model.$attr.multiple && queryValue2 && queryValue2.length) {
          return true
        }
        if (SINGLE_VALUE.includes(columnType) && queryValue) {
          return true
        }
        if (columnType === COLUMN_TYPE.number) {
          if (operation === OPERATIONS.between && !this.isEmpty(queryValue) && !this.isEmpty(model._queryValue)) {
            return true
          } else if (operation !== OPERATIONS.between && !this.isEmpty(queryValue)) {
            return true
          }
        }
        if (columnType === COLUMN_TYPE.enum || this.isAutoSwitch(model)) {
          if (this.isEmptyOperation(model) && queryValue) {
            return true
          }
          if (!this.isEmptyOperation(model) && queryValue2 && queryValue2.length) {
            return true
          }
        }
        if (columnType === COLUMN_TYPE.date) {
          const lookupCode = this.getSelectField(model).lookupCode
          if (lookupCode === 'datePicker2' && this.isDateMultiple(model)) {
            return queryValue2
          }
          if (!this.isRange(model) && (queryValue || model._queryValue === 'null')) {
            return true
          }
          if (this.isRange(model) && queryValue2 && queryValue2.length) {
            return true
          }
        }
        if ((columnType === COLUMN_TYPE.area || columnType === COLUMN_TYPE.dept || columnType === COLUMN_TYPE.customComponent) && queryValue2 && queryValue2.length) {
          return true
        }
        return false
      },
      isValidCompareOption (val, { key, columnType, operation }) {
        // 自定义条件关系
        let operations = (this.config.fields[key] && this.config.fields[key].$attr.operations) || COMPARES[columnType]
        if (operations) {
          return operations.includes(val)
        }
        return val === operation
      },
      // getValidConditions (model) {
      //   console.log(this.config.conditionOperation, model)
      //   let obj = this.getSelectField(model)
      //   let rowCondition = obj && obj.$attr && obj.$attr.rowCondition ? obj.$attr.rowCondition : false
      //   if (!rowCondition) {
      //     return this.config.conditionOperation
      //   } else {
      //     return this.config.conditionOperation.filter(e => e.value === rowCondition)
      //   }
      // },
      getFieldOptions (model) {
        let obj = this.getSelectField(model)
        // select 前端配置 options
        let arr = obj.$attr.options || this.lookUpOptions[obj.lookupCode] || []
        if (!obj.$attr.unNull && this.isEmptyOperation(model)) {
          arr = arr.concat([{ label: '(空)', value: 'null' }])
        }
        return arr
      },
      isDisabled (key, index) {
        if (key && this.config.fields[key] && this.config.fields[key].$attr.required) {
          // let firstIndex = this.rules.findIndex(v => v.key === key)
          // if (index === firstIndex) {
          //   return true
          // }
          return this.rules[index]._required
        }
        return false
      },
      showDeleteIcon (key, index) {
        return this.rules.length > 1 && (!key || !this.config.fields[key].$attr.required || !this.isDisabled(key, index))
      },
      showAddIcon (key, index) {
        const { maxRows } = this.$props
        if (maxRows && this.rules.length >= maxRows) {
          return false
        }
        return true
        // return index === 0 || index < this.rules.length - 1
      },
      getDatePickerType (key, isRange) {
        const config = this.config.fields[key]
        const type = config.$attr.type
        const isNewDate = ['datePicker2', 'datePicker3'].includes(config.lookupCode)
        if (isRange) {
          if (isNewDate && type === 'month') {
            return `${type}range`
          }
          return (type === 'date' || type === 'datetime') ? `${type}range` : 'daterange'
        }
        return type
      },
      getComponentType ({ propertyName, columnName, operation, columnType }) {
        return (propertyName || columnName) && operation && columnType
      },
      isInputComponent ({ columnType }) {
        return columnType === COLUMN_TYPE.string || columnType === COLUMN_TYPE.phone
      },
      isInputNumberComponent ({ columnType }) {
        return columnType === COLUMN_TYPE.number
      },
      isInputRange ({ columnType, operation }) {
        return columnType === COLUMN_TYPE.number && operation === OPERATIONS.between
      },
      getSelectField (model) {
        return this.config.fields[model.key] || {}
      },
      clearFieldValue (model) {
        // 因为每个字段的类型都不一样 这里清空上次的输入值
        let obj = this.getSelectField(model)
        let type = obj.columnType
        model.propertyName = obj.propertyName
        model.columnName = obj.columnName
        model.columnType = type
        model.operation = ''
        model.queryValue = ''
        model.queryValue2 = null
        model._queryValue = ''
        model.remoteMethod = null
        model.labelKey = ''
        model.valueKey = ''
        model._prevOperation = ''
        model.$attr = { ...(obj.$attr || {}) }
        // 员工、部门 等远程搜索select
        if (obj.remoteMethod) {
          this.$set(model, 'loading', false)
          this.$set(model, 'options', [])
          model.remoteMethod = obj.remoteMethod
          // 2023-04-26 解决多选下拉搜索，搜索字段在搜索结果返回后清空的情况
          if (model.$attr.multiple || (this.isAutoSwitch(model))) {
            model.queryValue2 = []
          }
          // 2022-11-28 增加属性
          model.labelKey = model.$attr.labelKey
          model.valueKey = model.$attr.valueKey
        }
        if (model.$attr.rowCondition) {
          model.conditionOperation = model.$attr.rowCondition
        }
        let conf = this.module.option[model.key]
        if (conf && typeof conf.fieldChange === 'function') {
          conf.fieldChange(model, this.config.fields, this.rules)
        }
        this.$emit('onFieldChange', model, this.config.fields, this.rules)
      },
      operationChange (model) {
        const operation = model.operation
        // const attr = model.$attr || {}
        if (typeof model.remoteMethod === 'function' && this.isAutoSwitch(model)) {
          const prevEmptyOperation = this.isEmptyOperation({ operation: model._prevOperation })
          const emptyOperation = this.isEmptyOperation({ operation })
          if ((prevEmptyOperation && !emptyOperation) || (!prevEmptyOperation && emptyOperation)) {
            model.queryValue = ''
            model.queryValue2 = []
          }
          // 动态切换是否多选，让内部方法执行接口缓存处理
          model.$attr.multiple = !this.isEmptyOperation(model)
        } else if (model.columnType === COLUMN_TYPE.date) {
          model.queryValue = model.operation === OPERATIONS.not_equal ? 'null' : model.queryValue
          if (this.isRange(model) || model._prevOperation === OPERATIONS.not_equal) {
            model.queryValue = ''
          } else {
            model.queryValue2 = null
          }
          model._queryValue = ''
        } else if (model.columnType === COLUMN_TYPE.enum) {
          model.queryValue2 = model.queryValue2 || []
          if (this.isEmptyOperation({ operation: model._prevOperation })) {
            model.queryValue2 = []
          } else {
            model.queryValue = ''
          }
        } else if (model.columnType === COLUMN_TYPE.number || this.isInputComponent({ columnType: model.columnType })) {
          const isNull = ['equal', 'not_equal'].includes(model.operation)
          model._queryValue = isNull ? model._queryValue : ''
          if (this.isInputRange(model)) {
            model.queryValue = ''
            model._queryValue = ''
          } else {
            model.queryValue = model._prevOperation === 'between' ? '' : model.queryValue
          }
        }

        model._prevOperation = model.operation

        let conf = this.module.option[model.key]
        if (conf && typeof conf.operationChange === 'function') {
          conf.operationChange(model, this.config.fields, this.rules)
        }
        this.$emit('onOperationChange', model, this.config.fields, this.rules)
      },
      queryValueChange (model) {
        let conf = this.module.option[model.key]
        if (conf && typeof conf.change === 'function') {
          let val = this.isEmptyOperation(model) ? model.queryValue : model.queryValue2
          conf.change(val, this.config.fields, this.rules, model)
        }
      },
      datePickerChange (value, model) {
        let conf = this.module.option[model.key]
        if (conf && typeof conf.change === 'function') {
          const key = model.key
          conf.change && conf.change({ key, value, model, fields: this.config.fields, rules: this.rules })
        }
      },
      selectVisibleChange (val, model) {
        // 远程下拉框可见时，同步下拉框
        if (val && !model.$attr.remote && typeof model.remoteMethod === 'function') {
          this.remoteMethod('--', model)
        } else {
          // 多选
          if (model.$attr.multiple && model.allSearchResult) {
            model.options = Object.keys(model.allSearchResult).reduce((prev, key) => {
              if (model.queryValue2.includes(key)) {
                const obj = model.allSearchResult[key]
                prev.push(obj)
              }
              return prev
            }, [])
          }
        }
      },
      async remoteMethod (val, model, index) {
        let arr = await remoteSelectMethod(val, model)
        if (arr.length) {
          // model.$attr.multiple && this.storeSearchResult(model)
          // 自动选中第一行
          this.$nextTick(_ => navigateSelectFirstOption(this.$refs[`remoteSelect${index}`], index))
        }
      },
      // /**
      //  * 2021-09-15
      //  * 多选远程搜索时，缓存所有的下拉值
      //  */
      // storeSearchResult (model) {
      //   let oldObj = model.allSearchResult || Object.create(null)
      //   let newObj = model.options.reduce((prev, cur) => {
      //     prev[cur.value] = cur
      //     return prev
      //   }, {})
      //   model.allSearchResult = { ...oldObj, ...newObj }
      // },
      async searchUser (val, field) {
        let key = field.$attr.valueKey || 'id'
        let fn = field.$attr.formatterOption || (v => `${v.chineseName}，${v.position || ''}，${v.departmentName}，${v.employeeNumber}`)
        let data = field.$attr.formatData || (val => (/^\d{4,}$/.test(val) ? { employeeNumber: val } : { chineseName: val }))
        let arr = await this.$http('data.employee.listByName', data(val))
        if (arr && arr.length) {
          arr.sort((a, b) => a.status - b.status)
          // arr = arr.slice(0, 10)
          arr.forEach(v => {
            v.optionDisabled = v.status === '20'
            v.label = fn(v)
            v.value = v[key]
          })
          return arr
        }
        return []
      },
      async searchDepartment (val) {
        let arr = await this.$http('hr.department.refactoring.getByFuzzyValue', { fuzzyValue: val })
        if (arr && arr.length) {
          return arr.map(v => ({ label: `${v.name}-${v.departmentCode}`, value: v.id }))
        }
        return []
      },
      formatTime (val, type) {
        return type === 'time' && val && val.length <= 8 ? new Date(`2000-01-01 ${val}`) : val
      },
      splitTime (val, type, format) {
        if (type === 'time' && val) {
          if (val instanceof Date) {
            val = moment(val).format(format || 'HH:mm:ss')
          }
          val = val.split(' ')[0]
        }
        return val
      },
      radioDateChange (model, val) {
        if (val === 'null') {
          model.queryValue = ''
        }
      },
      radioNumberChange (model, val) {
        if (val === 'null') {
          model.queryValue = 'null'
        } else {
          model.queryValue = ''
        }
      },
      radioInputChange (model, val) {
        if (val === 'null') {
          model.queryValue = ''
        }
      },
      /**
       * 计算日期区间
       * date: [2018-12-12 00:00:00, 2018-12-12 23:59:59]
       * datetime: [2018-12-12 12:12:00, 2018-12-12 12:12:59]
       * @param val
       * @param type
       */
      calculateDateRange (val, type, format) {
        if (type === 'date') {
          return [val, val.replace('00:00:00', '23:59:59')]
        } else if (type === 'datetime') {
          return [val.replace(/:\d{2}$/, ':00'), val.replace(/:\d{2}$/, ':59')]
        } else {
          return [this.splitTime(val, type, format)]
        }
      },
      isEmpty (val) {
        return val === '' || val === null || val === undefined
      },
      bindChange (val, model) {
        if (model.$attr.multiple) {
          model.queryValue2 = val
        } else {
          model.queryValue = val
        }
      },
      openDeptTree (row, index) {
        this.showIndex = index
        if (row.$attr.multiple) {
          this.$refs.deptMultipleDialog.open(row)
        } else {
          this.$refs.deptDialog.open(row)
        }
      },
      showDeptLabel (row) {
        let arr = row._queryValue
        if (arr && arr.length) {
          return arr.map(v => v.label).join()
        }
        return ''
      },
      deptChange (e) {
        // 是否包含子节点
        this.rules[this.showIndex]._containLeaf = e.leaf ? 1 : 0
        // id详情
        this.rules[this.showIndex]._idsInfo = e.idsInfo
      },
      // 获取多选下拉框选中的 labels，用于抓取导出查询参数的dom文本
      selectedLabels (options, val, multiple) {
        if (multiple && Array.isArray(options) && Array.isArray(val) && val.length) {
          return JSON.stringify(val.map(v => (options.find(o => v === o.value) || {}).label))
        }
        return ''
      },
      warpCustomComponentsOption (row) {
        row.setCustomValue = function (value = '', label = '') {
          let val = Array.isArray(value) ? value : [value]
          row.queryValue2 = val
          row.queryValue = label
          row._queryValue = [{ value: val, label }]
        }
        return row
      },
      setPlaceholder (row) {
        const placeholder = row.$attr.placeholder
        const openPlaceholder = row.$attr.openPlaceholder
        return openPlaceholder ? placeholder : ''
      },
      checkNodeSelect (...arg) {
        const rule = this.rules[this.showIndex]
        const { option } = this.$props.module || {}
        const filed = option[rule.propertyName] || {}
        const fn = filed.checkNodeSelect
        return typeof fn === 'function' ? fn(...arg, rule) : true
      }
    }
  }
</script>

<style lang="scss">
  .kye-filter-rule {
    .el-table__header-wrapper {
      tr {
          background-color: #F8F8F8;
        height: 36px;
      }
      th.is-leaf {
        border-bottom: none;
      }
    }
    .el-input__inner {
        padding: 0 4px !important;
    }
    .el-input--suffix .el-input__inner {
      padding-right: 16px !important;
      padding-left: 4px !important;
    }
    .kye-date-range__wrapper {
      padding-left: 4px !important;
      line-height: 30px;
    }
    .remote-area .area-item + .area-item {
      margin-left: 2px !important;
    }
    .el-table__body {
      padding: 0;
      padding-top: 8px;
    }
    .el-table .kye-filter-rule-cell .cell {
      padding: 3px;
    }
    .el-table::before {
      display: none;
    }
    .el-table th {
      background: none;
    }
    .el-table td {
      padding: 6px 0;
      border-bottom: none;
    }
    .el-table__body tr:hover > td,
    .el-table__body tr.current-row > td {
      background: #ffffff !important;
    }
    .layout-remove,
    .layout-plus2 {
      color: var(--g-color-primary);
      // border: 1px solid var(--g-color-primary);
      // border-radius: 9px;
      font-size: 14px;
      cursor: pointer;
      margin-left: 2px;
    }
    .layout-plus2 {
      margin-right: 2px;
    }
    .td-front.cell {
      padding-left: 40px !important;
    }
    .td-post.cell {
      padding-left: 6px !important;
    }
    .colindex.cellindex {
      display: inline-block;
      width: 28px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/custom-filter-rule.vue